import { render, staticRenderFns } from "./GalleryFolderItem.vue?vue&type=template&id=ac059fb8&scoped=true"
import script from "./GalleryFolderItem.vue?vue&type=script&lang=js"
export * from "./GalleryFolderItem.vue?vue&type=script&lang=js"
import style0 from "./GalleryFolderItem.vue?vue&type=style&index=0&id=ac059fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac059fb8",
  null
  
)

export default component.exports